import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material'
import React, { FC, useEffect, useState } from 'react'
import { useSearchParams } from '../../hooks'

type ComponentMenuOption = {
  title: string
  disabled?: boolean
  component: FC
}

function ComponentSelect({
  components,
  searchParamKey,
  onComponentSelect,
}: {
  components: ComponentMenuOption[]
  searchParamKey: string
  onComponentSelect?: (title?: string) => void
}) {
  const [CurrentComponent, setCurrentComponent] = useState<FC | undefined>()
  const [searchParams, setSearchParams] = useSearchParams()
  const currentSelected = searchParams.get(searchParamKey) ?? ''

  useEffect(() => {
    const option = components.find(({ title }) => title === currentSelected)
    setCurrentComponent(() => option?.component)
  }, [currentSelected, components])

  useEffect(() => {
    onComponentSelect?.(currentSelected)
  }, [onComponentSelect, currentSelected])

  const updateSelectedTool = (selected: string) => {
    setSearchParams({ [searchParamKey]: selected })
  }

  return (
    <Box>
      <FormControl>
        <InputLabel>Select Tool</InputLabel>
        <Select<string>
          value={currentSelected}
          label="Select Tool"
          onChange={(e) => updateSelectedTool(e.target.value as string)}
          sx={{
            width: 'auto',
            minWidth: '130px',
          }}
        >
          {components.map(({ title, disabled }) => {
            return (
              <MenuItem key={title} value={title} disabled={!!disabled}>
                {title}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
      <Button onClick={() => updateSelectedTool('')}>X</Button>
      {CurrentComponent && (
        <Box padding="10px">
          <CurrentComponent />
        </Box>
      )}
    </Box>
  )
}

export enum ComponentToolKeys {
  treeManagement = 'tMgmt',
  masterManagement = 'mMgmt',
  mastersManagement = 'msMgmt',
}

export function TreeManagementToolSelect({
  components,
}: {
  components: ComponentMenuOption[]
}) {
  return (
    <ComponentSelect
      components={components}
      searchParamKey={ComponentToolKeys.treeManagement}
    />
  )
}

export function MastersManagementToolSelect({
  components,
}: {
  components: ComponentMenuOption[]
}) {
  return (
    <ComponentSelect
      components={components}
      searchParamKey={ComponentToolKeys.mastersManagement}
    />
  )
}

export function MasterManagementToolSelect({
  components,
  onComponentSelect,
}: {
  components: ComponentMenuOption[]
  onComponentSelect?: (title?: string) => void
}) {
  return (
    <ComponentSelect
      components={components}
      onComponentSelect={onComponentSelect}
      searchParamKey={ComponentToolKeys.masterManagement}
    />
  )
}
